import { FC } from 'react'
import { Navigate, Outlet } from 'react-router-dom'
import { useAppSelector } from 'store/hooks'
import BackgroundImage from './components/BackgroundImage'
import * as Styles from './PublicLayout.styles'

const PublicLayout: FC = () => {
  const { token } = useAppSelector((state) => state.auth)

  if (token) {
    const dashboardRoute = '/admin/dashboard'
    return <Navigate to={dashboardRoute} replace />
  }

  return (
    <Styles.Container>
      <Styles.LeftColumn>
        <BackgroundImage />
      </Styles.LeftColumn>
      <Styles.RightColumn>
        <Styles.Logo src="/images/logo.png" alt="SureFire" />
        <Styles.Header>
          <Styles.MobileLogo src="/images/mobile-logo.png" alt="SureFire" />
        </Styles.Header>
        <Styles.Content>
          <Outlet />
        </Styles.Content>
      </Styles.RightColumn>
    </Styles.Container>
  )
}
export default PublicLayout
